const SITE_NAME = 'Estate Rwanda'
const DEFAULT_TITLE = "Estate Rwanda — Rwanda's Premier Property Platform"
const DEFAULT_DESCRIPTION = 'Find houses, apartments, and land for sale and rent across Rwanda. Browse verified listings from trusted real estate agents in Kigali, Gasabo, Nyarugenge, and beyond.'
const DEFAULT_KEYWORDS = 'Rwanda real estate, property Rwanda, houses for sale Kigali, apartments for rent Kigali, land Rwanda, real estate agent Rwanda, Estate Rwanda'
const DEFAULT_IMAGE = 'https://estaterwanda.com/og-cover.jpg'

export interface SeoOptions {
  title?: string
  description?: string
  keywords?: string
  image?: string
  type?: 'website' | 'article'
  canonical?: string
}

function setMeta (selector: string, content: string) {
  let el = document.querySelector(selector)
  if (!el) {
    // Parse attribute from selector, e.g. meta[name="description"]
    const tagMatch = selector.match(/^(\w+)\[(\w+)="([^"]+)"\]$/)
    if (!tagMatch) return
    el = document.createElement(tagMatch[1])
    el.setAttribute(tagMatch[2], tagMatch[3])
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical (url: string) {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.href = url
}

export function setSeo (options: SeoOptions = {}) {
  const title = options.title
    ? `${options.title} | ${SITE_NAME}`
    : DEFAULT_TITLE
  const description = options.description || DEFAULT_DESCRIPTION
  const keywords = options.keywords
    ? `${options.keywords}, Rwanda real estate, Estate Rwanda`
    : DEFAULT_KEYWORDS
  const image = options.image || DEFAULT_IMAGE
  const url = options.canonical || window.location.href
  const type = options.type || 'website'

  // Page title
  document.title = title

  // Standard meta
  setMeta('meta[name="description"]', description)
  setMeta('meta[name="keywords"]', keywords)
  setMeta('meta[name="robots"]', 'index, follow')
  setMeta('meta[name="author"]', SITE_NAME)

  // Open Graph (Facebook, LinkedIn, WhatsApp previews)
  setMeta('meta[property="og:title"]', title)
  setMeta('meta[property="og:description"]', description)
  setMeta('meta[property="og:image"]', image)
  setMeta('meta[property="og:url"]', url)
  setMeta('meta[property="og:type"]', type)
  setMeta('meta[property="og:site_name"]', SITE_NAME)
  setMeta('meta[property="og:locale"]', 'en_RW')

  // Twitter Card
  setMeta('meta[name="twitter:card"]', 'summary_large_image')
  setMeta('meta[name="twitter:title"]', title)
  setMeta('meta[name="twitter:description"]', description)
  setMeta('meta[name="twitter:image"]', image)

  // Canonical
  setCanonical(url)
}

export function resetSeo () {
  setSeo()
}
